// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"19351":"a5ce6a92","23644":"1c8a7e20"}[chunkId] || chunkId) + "." + {"19351":"c1f7de0082641d15","23644":"0249cc75c98e07c3","33509":"4c3abf7acbd0c23b","53348":"d8fff340f695c7fb","57238":"fb97c86eefde2caa","64645":"535efdb6394d3327"}[chunkId] + ".js";
};